module.exports = __webpack_public_path__ + "img/31_27.0fc0acd3.png";